import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-buy-sell-request-form',
  templateUrl: './buy-sell-request-form.component.html',
  styleUrls: ['./buy-sell-request-form.component.scss']
})
export class BuySellRequestFormComponent implements OnInit {
  @Input() buySellPlanEmployee: any;
  @Input() employeeTimeOffType: any;
  @Input() compensation: any;
  @Input() buySellPlan: any;

  private _hoursInput: number = 0;
  @Input()
  set hoursInput(value: number) {
    this._hoursInput = value ?? 0;
    this.hoursInputChange.emit(this._hoursInput);
  }
  get hoursInput(): number {
    return this._hoursInput;
  }

  private _selectedType: string = 'BUY';
  @Input()
  set selectedType(value: string) {
    this._selectedType = value;
    this.selectedTypeChange.emit(this._selectedType);
  }
  get selectedType(): string {
    return this._selectedType;
  }

  @Output() requestSubmitted = new EventEmitter<void>();
  @Output() hoursInputChange = new EventEmitter<number>();
  @Output() selectedTypeChange = new EventEmitter<string>();

  constructor() { }
  
  ngOnInit(): void {
  }
  
  onSubmit(): void {
    this.requestSubmitted.emit();
  }
}
